import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiResponseModel, ApiVisa, Pagination, PagingResponseModel } from '../shared';
import {ClientSidePermissionRoleLinkContainerModel} from '../../../../../models/aggregates/permissions';


// core2/tnt/dm/applet/client-side-permission-role-links/

@Injectable({ providedIn: 'root' })
export class ClientSidePermissionRoleLinksTenantAdminService extends BaseApiTemplateService<ClientSidePermissionRoleLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permission-role-links';
    this.endpoint_path = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permission-role-links';
    this.httpClient = http;
  }

    // client-side-permission-role-links/{clientPermGuid}/custom-role-from-link/{tenantCode}/{appletGuid}/tenant-admin-ep/query
  getByCriteriTenantAdminSpecialEp(tenantCode: string, appletGuid: string, permGuid: string, pagination: Pagination, apiVisa: ApiVisa): Observable<PagingResponseModel<ClientSidePermissionRoleLinkContainerModel>> {

    if (apiVisa && apiVisa.api_domain_url != null) {
      this.apiUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permission-role-links';
    }
    const url = this.apiUrl + '/' + permGuid + '/custom-role-from-link/' + tenantCode + '/' + appletGuid + '/tenant-admin-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<ClientSidePermissionRoleLinkContainerModel>>(
      url,
      this.getHttpHeader(apiVisa)
    );
  }

   // client-side-permission-role-links/custom-modify/tenant-admin-ep
  updatePermissionsCustom(dtoObject: any, apiVisa: ApiVisa) {
    if (apiVisa && apiVisa.api_domain_url != null) {
      this.apiUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permission-role-links/custom-modify/' + BaseApiTemplateService.TENANT_ADMIN_EP;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }


  // /custom-retrieve-client-side-perm-dfn/tenant-admin-ep/query?

  getByCriteriTenantAdminSpecialEpReverse(
    dtoObject: any,
    pagination: Pagination,
    apiVisa: ApiVisa
  ): Observable<PagingResponseModel<ClientSidePermissionRoleLinkContainerModel>> {

    if (apiVisa && apiVisa.api_domain_url != null) {
      this.apiUrl = apiVisa.api_domain_url
        + Core2Config.TENANT_DOMAIN_URL_PREFIX
        + Core2Config.APPLET_PREFIX
        + 'client-side-permission-role-links/';
    }

    const url = this.apiUrl + 'custom-retrieve-client-side-perm-dfn/tenant-admin-ep/query?' + pagination.getQueryKeyValues();

    return this.httpClient.post<PagingResponseModel<ClientSidePermissionRoleLinkContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }


     // client-side-permission-role-links/custom-modify-revise/tenant-admin-ep
  updatePermissionsCustomReverse(dtoObject: any, apiVisa: ApiVisa) {
    if (apiVisa && apiVisa.api_domain_url != null) {
      this.apiUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'client-side-permission-role-links/custom-modify-revise/' + BaseApiTemplateService.TENANT_ADMIN_EP;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }

}
